<mat-card class="page-header mat-elevation-z0">
    <mat-card-title>Maintenance</mat-card-title>
</mat-card>
<mat-divider></mat-divider>
<app-garbage-collector-section></app-garbage-collector-section>
<mat-divider></mat-divider>